export const extractCssVariablesFromTheme = (
  variables: { title: string; name: string; variable: string }[],
): string[] => variables?.map(variable => variable.variable) ?? [];
